module.exports = __webpack_public_path__ + "static/media/statistic.1404d27c.svg";